'use client';

import { ThemeProvider } from 'next-themes';
import { NextIntlClientProvider } from 'next-intl';
import { TelegramProvider } from '@/lib/TelegramProvider';
import { Toaster } from 'react-hot-toast';

type ProvidersProps = {
  children: React.ReactNode;
  locale: string;
  messages: Record<string, unknown>;
  timeZone: string;
};

export default function Providers({ children, locale, messages, timeZone }: ProvidersProps) {
  return (
    <TelegramProvider>
      <NextIntlClientProvider messages={messages} locale={locale} timeZone={timeZone}>
        <ThemeProvider attribute="data-theme" defaultTheme="system" enableSystem>
          <Toaster />
          {children}
        </ThemeProvider>
      </NextIntlClientProvider>
    </TelegramProvider>
  );
}
